import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import HrStore from 'stores/HrStore'
import { momentHelper } from '../../report/helpers'
import './Print.css'

const DEFAULT_ROW = 21
class PrintSlipTableDoc extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],config:{},report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('landscape');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        let range = {resulttype:this.props.resulttype,value:this.props.value,start:this.props.start,end:this.props.end}
        let {emType} = this.props
        if(emType==='daily'){
            HrStore.loadAllSlipDailyWage(this.props.year,this.props.month,range,(result)=>{
                this.setState({report_title:'ไม่พบข้อมูล',config:result,dataList:this.getPagination(result.data)})
            },()=>{
                this.setState({report_title:'เกิดข้อผิดพลาด'})
            })
        }else{
            HrStore.loadAllSlipMonthlyWage(this.props.year,this.props.month,range,(result)=>{
                this.setState({report_title:'ไม่พบข้อมูล',config:result,dataList:this.getPagination(result.data)})
            },()=>{
                this.setState({report_title:'เกิดข้อผิดพลาด'})
            })
        }
    }

    getDate() {
        let {value,year,month} = this.props
        let text = 'ประจำวันที่ '
        text += value+' '+momentHelper.getMonthText(month)+' '+year
        return text
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    getHiddenClass(key=''){
        let {config} = this.state
        if(config.hidden_key_field_print.includes(key)){
            return 'hide'
        }else{
            return ''
        }
    }

    getTableTitle(key){
        const {config} = this.state
        if(config.table_key_name[key]!==undefined){
            return config.table_key_name[key];
        }else{
            return key;
        }
    }

    getTotalColumn(filedList){
        let {config} = this.state
        let list = filedList.reduce((rresult,item,index)=>{
            if(config.hidden_key_field_print.includes(item)){
    
            }else{
                rresult.push(item)
            }
            return rresult;
        },[])
        return list.length
    }

    getTableData(item,key,rowIndex){
        if(item[key]!==undefined){
            return <div>{this.renderEditColumn(item[key],rowIndex,key)}</div>;
        }else{
            return "!Error";
        }
    }

    getFooterData(sumList,key){
        if(sumList[key]!==undefined){
            return this.getNumberFormat(sumList[key])
        }else{
            return '!Error';
        }
    }

    sumTable(tableList){
        let sumList = {}
        if(tableList.length>0)
            sumList = new Array(tableList[0].length).fill(0)

        tableList.map((item,index)=>{
            Object.keys(item).forEach((key)=>{
                if(!isNaN(item[key])){
                    if(sumList[key]===undefined)
                        sumList[key] = 0

                    sumList[key] += item[key]*1
                }
            })
            return item;
        })
        return sumList
    }

    renderEditColumn(item,rowIndex,index){
        let value = item
        if(item!==null && item!=='' && typeof item.value !=='undefined')
            return(<div>{item.value}</div>)
        else {
            if (isNaN(item)||index==='count_office_work'||index==='expected_work_days'||index==='ot_hour_afterwork'||index==='ot_hour_weekend')
                return(<div className='text-center'>{item}</div>)
            else 
                return(<div>{this.getNumberFormat(value)}</div>)
        }    
    }

    renderHeader(item,index,length) {
        let {config} = this.state
        let otherInfoColSpan = this.getTotalColumn(config.table_key_field.other_info)
        return(
            <thead>
                <tr>
                    <th rowSpan="2" className={this.getHiddenClass('slip_no')} style={{width:'80px'}}>เลขสลิป</th>
                    <th colSpan={this.getTotalColumn(config.table_key_field.employee_info)} className='text-center'>ข้อมูลทั่วไป</th>        
                    <th colSpan={this.getTotalColumn(config.table_key_field.income)} className='text-center'>รายรับ</th>
                    <th rowSpan="2" className={'bg-green '+this.getHiddenClass('total_income')}>รายได้ทั้งหมด</th>
                    <th colSpan={this.getTotalColumn(config.table_key_field.deduction)} className='text-center'>รายจ่าย</th>
                    <th rowSpan="2" className={this.getHiddenClass('total_deduction')} >รายหักทั้งหมด</th>
                    <th colSpan="2" className={'text-center '+this.getHiddenClass('net_payable')} >คงเหลือ</th>
                    <th colSpan={otherInfoColSpan} className={'text-center '+(otherInfoColSpan===0?'hide':'')}>ข้อมูลอื่นๆ</th>
                </tr>
                <tr role="row">
                    {
                        config.table_key_field.employee_info.map((key,index)=>{                      
                            return (
                                <th key={index} className={'text-center '+this.getHiddenClass(key)}>{this.getTableTitle(key)}</th>
                            )
                        })
                    }
                    {
                        config.table_key_field.income.map((key,index)=>{                      
                            return (
                                <th key={index} className={'text-center '+this.getHiddenClass(key)} >{this.getTableTitle(key)}</th>
                            )
                        })
                    }
                    {
                        config.table_key_field.deduction.map((key,index)=>{                      
                            return (
                                <th key={index} className={'text-center '+this.getHiddenClass(key)} >{this.getTableTitle(key)}</th>
                            )
                        })
                    }
                    <th className={'bg-red '+this.getHiddenClass('net_income')}>คงเหลือจ่ายจริง</th>                    
                    <th className={this.getHiddenClass('net_payable')} >คงเหลือค้างจ่าย</th>
                    {
                        config.table_key_field.other_info.map((key,index)=>{                      
                            return (
                                <th key={index} className={'text-center '+this.getHiddenClass(key)} >{this.getTableTitle(key)}</th>
                            )
                        })
                    }
                </tr>
            </thead>                
        )
    }

    renderTableList(items,indexs,length) {
        let {config} = this.state
        let tableList = items
        if(tableList.length>0){
            return tableList.map((item,rowIndex)=>(
                <tr key={rowIndex}>
                    <td  className={'text-center '+this.getHiddenClass('slip_no')} >{this.getTableData(item,'slip_no',rowIndex)}</td>
                    {
                        config.table_key_field.employee_info.map((key,index)=>{                      
                            return (
                                <td key={index} className={'text-center '+this.getHiddenClass(key)} >{this.getTableData(item,key,rowIndex)}</td>
                            )
                        })
                    }
                    {
                        config.table_key_field.income.map((key,index)=>{                      
                            return (
                                <td key={index} className={'text-right '+this.getHiddenClass(key)} >{this.getTableData(item,key,rowIndex)}</td>
                            )
                        })
                    }
                    <td  className='text-right' >{this.getTableData(item,'total_income',rowIndex)}</td>
                    {
                        config.table_key_field.deduction.map((key,index)=>{                      
                            return (
                                <td key={index} className={'text-right '+this.getHiddenClass(key)} >{this.getTableData(item,key,rowIndex)}</td>
                            )
                        })
                    }
                    <td  className={'text-right '+this.getHiddenClass('total_deduction')} >{this.getTableData(item,'total_deduction',rowIndex)}</td>
                    <td  className={'text-right '+this.getHiddenClass('net_income')} >{this.getTableData(item,'net_income',rowIndex)}</td>  
                    <td  className={'text-right '+this.getHiddenClass('net_payable')} >{this.getTableData(item,'net_payable',rowIndex)}</td>
                    {
                        config.table_key_field.other_info.map((key,index)=>{                      
                            return (
                                <td key={index} className={'text-center '+this.getHiddenClass(key)} >{this.getTableData(item,key,rowIndex)}</td>
                            )
                        })
                    }
                </tr>
            ))
        } else{
            let colSpan = this.getTotalColumn(config.table_key_field.employee_info)+this.getTotalColumn(config.table_key_field.income)+
            this.getTotalColumn(config.table_key_field.deduction)+this.getTotalColumn(config.table_key_field.other_info)+5
            return (<tr><td colSpan={colSpan}>ยังไม่พบข้อมูล</td></tr>)
        }
    }

    renderFooter(items,indexs,length){
        let {config} = this.state
        let tableList = items
        let sumList = this.sumTable(tableList)
        let title = 'รวมค่าแรงรายวัน'
        if(tableList.length===0){
          return ('')
        }
    
        let otherInfoColSpan = this.getTotalColumn(config.table_key_field.other_info)
        return (
            <tr>
                <th colSpan={this.getTotalColumn(config.table_key_field.employee_info)+1} className='text-right'  >{title}</th>
                {
                config.table_key_field.income.map((key,index)=>{                      
                    return (
                        <th key={index} className={'text-right '+this.getHiddenClass(key)} >{this.getFooterData(sumList,key)}</th>
                    )
                })
                }
                <th  className={'text-right '+this.getHiddenClass('total_income')} >{this.getFooterData(sumList,'total_income')}</th>
                {
                config.table_key_field.deduction.map((key,index)=>{                      
                    return (
                        <th key={index} className={'text-right '+this.getHiddenClass(key)} >{this.getFooterData(sumList,key)}</th>
                    )
                })
                }
                <th  className='text-right' >{this.getFooterData(sumList,'total_deduction')}</th>
                <th  className='text-right' >{this.getFooterData(sumList,'net_income')}</th>  
                <th  className='text-right' >{this.getFooterData(sumList,'net_payable')}</th>
                {otherInfoColSpan===0?'':<th  colSpan={otherInfoColSpan} className={'text-right '+(otherInfoColSpan===0?'hide':'')} ></th>}
            </tr>
        )
    }

    renderTable(item,index,length) {
        return(
            <div>
                <table className='table table-print-slip-doc' style={{marginBottom:'0'}}>
                    {this.renderHeader(item,index,length)}
                    <tbody>
                        {this.renderTableList(item,index,length)}
                    </tbody>
                    {length-1===index?
                    <tfoot>                  
                        {this.renderFooter(item,index,length)}                  
                    </tfoot>
                    :''}
              </table>
            </div>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title+' '+this.getDate()}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }

    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length===0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title+' '+this.getDate()}
                    size='landscape'
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title+' '+this.getDate()}
                    size='landscape'
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}    
PrintSlipTableDoc.defaultProps = {
    title:'ตารางการจ่ายเงินพนักงานรายวัน',
    emType:''
}
export default PrintSlipTableDoc;    


// WEBPACK FOOTER //
// ./src/view/print/hr/PrintSlipTableDoc.js